<template>
  <div>
    <vs-card>
      <ag-grid-vue
        style="width: 100%; height: 500px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="orderListClmn"
        :rowData="pendingOrderList"
        :localeText="localeText"
        :rowSelection="rowSelection"
        @grid-ready="onGridReady"
         :suppressCopyRowsToClipboard="true"
      >
      </ag-grid-vue>
    </vs-card>
    <div :hidden="invoiceValidate">
      <Invoice ref="invoice" />
    </div>
    <vs-prompt
      title="Sepet"
      acceptText="Onayla"
      cancelText="Vazgeç"
      @accept="orderDeleteControl"
      :active.sync="activePrompt"
    >
      <div style="text-align: center" class="con-exemple-prompt">
        <span
          >Sepet silinecek?<br />
          Bunu geri alamazsınız !</span
        >
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import Invoice from "../products/Invoice.vue";
import Store from "../../store/store";
import state from "../../store/state";
import router from "../../router";
import moment from "moment";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import TextGorunumCellRenderer from "./CellRenderer/TextGorunumCellRenderer";
import PendingOrdersButton from "./CellRenderer/PendingOrdersButton.vue";
export default {
  components: {
    Invoice,
    AgGridVue,
    TextGorunumCellRenderer,
    PendingOrdersButton,
  },
  data() {
    return {
      deletedParam:[],
      activePrompt:false,
      orderListClmn: null,
      rowSelection: null,
      localeText: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      invoiceValidate: true,
      dir: false,
      pageLength: 50,
      secilenStok: [],
      checkSelected: [],
      pendingOrderList: [],
      columns: [
        {
          label: "Sipariş Tarihi",
          field: "TARIH",
        },
        {
          label: "Cari Kod",
          field: "CARI_KOD",
        },
        {
          label: "Cari Adı",
          field: "CARIADI",
        },

        {
          label: "İl",
          field: "IL",
        },
        {
          label: "Toplam Parça",
          field: "TOPPARCA",
        },
        {
          label: "Onay durumu",
          field: "ONAY",
        },

        {
          field: "action",
        },
        /*  {
          label: "Action",
          field: "action",
        },*/
      ],
    };
  },
  created() {
    this.pendingOrder();

    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.rowSelection = "single";
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    rowStyleClassFn(row) {
      if (row.Onay == "Onay") return "VGT-row";
    },
    parseDate(date) {
      return moment(String(date)).format("DD.MM.YYYY");
    },
    checkoutRoute() {},
    orderDeleteControl() { 
      var vm = this;
      var vs = this.$vs;
      const args = {
        token: state.tokenId,
        CARIKOD: this.deletedParam.CARI_KOD,
        ONAY: this.deletedParam.onay,
        orderNumber: this.deletedParam.orderNumber,
      }; 
      vm.$store.dispatch("eCommerce/deleteDataToCard", args).then((response) => {
        vm.pendingOrder(); 
      });
    },
    deleteCardDetay( ) {
      this.activePrompt = true      
    },
    stockDetail(param) { 
      var vm = this;
      var vs = this.$vs;
      const args = {
        token: state.tokenId,
        CARIKOD: param.CARI_KOD,
        ONAY: param.onay,
        ROL: state.ROL,
        orderNumber: param.orderNumber,
      }; 
      vm.$store.dispatch("getDataSepet", args).then((response) => { 
        router.push({
          name: "products-checkout",
          params: { onayDurumu: "Onay", orderNumber: param.orderNumber },
        });
      });
    },
    selectionChanged(params) {
      this.secilenStok = params.selectedRows;
    },
    pendingOrder() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.B2B_SepetOnayBekleyen(args, function (err, result) {
          if (result.B2B_SepetOnayBekleyenResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.B2B_SepetOnayBekleyenResult);
            vm.pendingOrderList = vm.veriler; 
          } catch (error) {
            console.log(result);
          }
        });
      });
    },
  },
  beforeMount() {
    this.orderListClmn = [
      {
        cellRenderer: "PendingOrdersButton",
        width: 250,
      },
      {
        headerName: "Sipariş Numarası",
        field: "orderNumber",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },

        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        width: 200,
        cellClass: "textType",
      },
      {
        headerName: "Tarih",
        field: "TARIH",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) => this.parseDate(params.data.TARIH),
      },
      {
        headerName: "Cari Adı",
        field: "CARIADI",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },

        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        width: 200,
        cellClass: "textType",
      },
      {
        headerName: "Cari Kodu",
        field: "CARI_KOD",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        width: 200,
        cellClass: "textType",
      },
      {
        headerName: "İl",
        field: "IL",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        width: 200,
        cellClass: "textType",
      },
      {
        headerName: "İlçe",
        field: "ILCE",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        width: 200,
        cellClass: "textType",
      },
      {
        headerName: "Toplam Adet",
        field: "TOPPARCA",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        width: 200,
        cellClass: "textType",
      },
    ];
  },
  mounted() {
    this.$root.$on("getCardDetay", (params) => {
      this.stockDetail(params);
    });
    this.$root.$on("deleteCardDetay", (params) => {
      this.deletedParam = params
      this.deleteCardDetay(params);
    });
  },
  beforeDestroy() {
    this.$root.$off("getCardDetay");
    this.$root.$off("deleteCardDetay");
  },
};
</script>
<style lang="scss">
table.vgt-table {
  font-size: small;
}

.VGT-row {
  background-color: yellow;
}
</style>
